import React from 'react';
import ServicesSection from '../components/ServicesSection';
import PageHeader from '../components/PageHeader';
import usePageMeta from '../hooks/usePageMeta';

const Services = () => {
  usePageMeta({
    title: 'Discipline Services — Spanking, OTK, Paddling, Whipping, Caning',
    description: 'Seattle spanking disciplinarian services: OTK (over-the-knee) spankings, paddling, whipping, caning, hairbrush, and belt discipline. Real Spankings, Life Coaching, Spanking Therapy, and Spousal Discipline in Western Washington.',
    path: '/services',
  });
  return (
    <div>
      <PageHeader
        eyebrow="What I offer"
        title="Discipline Services"
        subtitle="Real accountability. Real consequences. Real change."
      />
      <ServicesSection />
    </div>
  );
};

export default Services;
